/**
 * Landing Page - Menu kotwic i smooth scroll
 */
export default function initializeLandingPage() {
    if (!document.querySelector('.site-header--landing-page')) {
        return;
    }

    const navContainer = document.getElementById('landing-page-nav-items');
    const mobileNavContainer = document.getElementById('landing-page-mobile-nav');
    const mobileToggle = document.getElementById('landing-page-mobile-toggle');
    const mobileMenu = document.getElementById('landing-page-mobile-menu');

    if (!navContainer && !mobileNavContainer) {
        return;
    }

    // Pobieranie wszystkich sekcji
    const sections = document.querySelectorAll('.landing-section[data-section-title]');
    
    if (sections.length === 0) {
        return;
    }

    // Generowanie menu
    const generateMenu = () => {
        const menuItems = [];
        const mobileMenuItems = [];

        sections.forEach((section, index) => {
            const title = section.getAttribute('data-section-title');
            const id = section.id;

            if (!title || !id) {
                return;
            }

            // Desktop menu item
            const menuItem = document.createElement('a');
            menuItem.href = `#${id}`;
            menuItem.className = 'header-landing-page__nav-item';
            menuItem.textContent = title.toUpperCase();
            menuItem.setAttribute('data-section-id', id);
            
            // Ikona strzałki (użyjemy prostego SVG)
            const icon = document.createElement('span');
            icon.className = 'header-landing-page__nav-item-icon';
            icon.innerHTML = `
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 2L5 8M5 8L2 5M5 8L8 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;
            menuItem.appendChild(icon);

            menuItem.addEventListener('click', (e) => {
                e.preventDefault();
                scrollToSection(id);
                updateActiveMenuItem(id);
            });

            menuItems.push(menuItem);

            // Mobile menu item
            const mobileMenuItem = document.createElement('a');
            mobileMenuItem.href = `#${id}`;
            mobileMenuItem.className = 'header-landing-page__mobile-nav-item';
            mobileMenuItem.textContent = title.toUpperCase();
            mobileMenuItem.setAttribute('data-section-id', id);

            mobileMenuItem.addEventListener('click', (e) => {
                e.preventDefault();
                scrollToSection(id);
                updateActiveMenuItem(id);
                closeMobileMenu();
            });

            mobileMenuItems.push(mobileMenuItem);
        });

        // Dodanie elementów do menu
        if (navContainer) {
            navContainer.innerHTML = '';
            menuItems.forEach(item => navContainer.appendChild(item));
        }

        if (mobileNavContainer) {
            mobileNavContainer.innerHTML = '';
            mobileMenuItems.forEach(item => mobileNavContainer.appendChild(item));
        }

        // Obserwowanie scrolla do aktualizacji aktywnego elementu
        observeSections();
    };

    // Smooth scroll do sekcji
    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            const headerHeight = document.querySelector('.header-landing-page')?.offsetHeight || 80;
            const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = sectionPosition - headerHeight - 20;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    // Aktualizacja aktywnego elementu menu
    const updateActiveMenuItem = (activeId) => {
        // Desktop
        const desktopItems = document.querySelectorAll('.header-landing-page__nav-item');
        desktopItems.forEach(item => {
            if (item.getAttribute('data-section-id') === activeId) {
                item.classList.add('header-landing-page__nav-item--active');
            } else {
                item.classList.remove('header-landing-page__nav-item--active');
            }
        });

        // Mobile
        const mobileItems = document.querySelectorAll('.header-landing-page__mobile-nav-item');
        mobileItems.forEach(item => {
            if (item.getAttribute('data-section-id') === activeId) {
                item.classList.add('header-landing-page__mobile-nav-item--active');
            } else {
                item.classList.remove('header-landing-page__mobile-nav-item--active');
            }
        });
    };

    // Obserwowanie sekcji podczas scrolla
    const observeSections = () => {
        const headerHeight = document.querySelector('.header-landing-page')?.offsetHeight || 80;
        const offset = headerHeight + 50;

        const observerOptions = {
            root: null,
            rootMargin: `-${offset}px 0px -50% 0px`,
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const sectionId = entry.target.id;
                    updateActiveMenuItem(sectionId);
                }
            });
        }, observerOptions);

        sections.forEach(section => {
            observer.observe(section);
        });
    };

    // Mobile menu toggle
    if (mobileToggle && mobileMenu) {
        mobileToggle.addEventListener('click', () => {
            mobileToggle.classList.toggle('header-landing-page__mobile-toggle--active');
            mobileMenu.classList.toggle('header-landing-page__mobile-menu--active');
        });

        // Zamknięcie menu po kliknięciu poza nim
        document.addEventListener('click', (e) => {
            if (!mobileMenu.contains(e.target) && !mobileToggle.contains(e.target)) {
                mobileToggle.classList.remove('header-landing-page__mobile-toggle--active');
                mobileMenu.classList.remove('header-landing-page__mobile-menu--active');
            }
        });
    }

    const closeMobileMenu = () => {
        if (mobileToggle && mobileMenu) {
            mobileToggle.classList.remove('header-landing-page__mobile-toggle--active');
            mobileMenu.classList.remove('header-landing-page__mobile-menu--active');
        }
    };

    // Inicjalizacja
    generateMenu();
}
